angular.module('portal.countries').constant('ShareCrfDefaultCountries', {
    es: {
        AF: 'Afganistán',
        AX: 'Åland',
        AL: 'Albania',
        DE: 'Alemania',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguila',
        AG: 'Antigua y Barbuda',
        AN: 'Antillas Holandesas',
        AQ: 'Antártida',
        SA: 'Arabia Saudita',
        DZ: 'Argelia',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaiyán',
        BS: 'Bahamas',
        BD: 'Bangladés',
        BB: 'Barbados',
        BH: 'Baréin',
        BZ: 'Belice',
        BJ: 'Benín',
        BM: 'Bermudas',
        BY: 'Bielorrusia',
        BO: 'Bolivia',
        BQ: 'Bonaire, San Eustaquio y Saba',
        BA: 'Bosnia y Herzegovina',
        BW: 'Botsuana',
        BR: 'Brasil',
        BN: 'Brunéi',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        BT: 'Bután',
        BE: 'Bélgica',
        CV: 'Cabo Verde',
        KH: 'Camboya',
        CM: 'Camerún',
        CA: 'Canadá',
        QA: 'Catar',
        TD: 'Chad',
        CL: 'Chile',
        CN: 'China',
        CY: 'Chipre',
        CO: 'Colombia',
        KM: 'Comoras',
        KP: 'Corea del Norte',
        KR: 'Corea del Sur',
        CI: 'Costa de Marfil',
        CR: 'Costa Rica',
        HR: 'Croacia',
        CU: 'Cuba',
        CW: 'Curazao',
        DK: 'Dinamarca',
        DM: 'Dominica',
        EC: 'Ecuador',
        EG: 'Egipto',
        SV: 'El Salvador',
        AE: 'Emiratos Árabes Unidos',
        ER: 'Eritrea',
        SK: 'Eslovaquia',
        SI: 'Eslovenia',
        ES: 'España',
        US: 'Estados Unidos',
        EE: 'Estonia',
        ET: 'Etiopía',
        PH: 'Filipinas',
        FI: 'Finlandia',
        FJ: 'Fiyi',
        FR: 'Francia',
        GA: 'Gabón',
        GM: 'Gambia',
        GE: 'Georgia',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Granada',
        GR: 'Grecia',
        GL: 'Groenlandia',
        GP: 'Guadalupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GF: 'Guayana Francesa',
        GG: 'Guernsey',
        GQ: 'Guinea Ecuatorial',
        GW: 'Guinea-Bisáu',
        GN: 'Guinea',
        GY: 'Guyana',
        HT: 'Haití',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungría',
        IN: 'India',
        ID: 'Indonesia',
        IQ: 'Irak',
        IE: 'Irlanda',
        IR: 'Irán',
        BV: 'Isla Bouvet',
        IM: 'Isla de Man',
        CX: 'Isla de Navidad',
        IS: 'Islandia',
        KY: 'Islas Caimán',
        CC: 'Islas Cocos',
        CK: 'Islas Cook',
        FO: 'Islas Feroe',
        GS: 'Islas Georgias del Sur y Sandwich del Sur',
        HM: 'Islas Heard y McDonald',
        FK: 'Islas Malvinas',
        MP: 'Islas Marianas del Norte',
        MH: 'Islas Marshall',
        PN: 'Islas Pitcairn',
        SB: 'Islas Salomón',
        TC: 'Islas Turcas y Caicos',
        UM: 'Islas ultramarinas de Estados Unidos',
        VG: 'Islas Vírgenes Británicas',
        VI: 'Islas Vírgenes de los Estados Unidos',
        IL: 'Israel',
        IT: 'Italia',
        JM: 'Jamaica',
        JP: 'Japón',
        JE: 'Jersey',
        JO: 'Jordania',
        KZ: 'Kazajistán',
        KE: 'Kenia',
        KG: 'Kirguistán',
        KI: 'Kiribati',
        XK: 'Kosovo',
        KW: 'Kuwait',
        LA: 'Laos',
        LS: 'Lesoto',
        LV: 'Letonia',
        LR: 'Liberia',
        LY: 'Libia',
        LI: 'Liechtenstein',
        LT: 'Lituania',
        LU: 'Luxemburgo',
        LB: 'Líbano',
        MO: 'Macao',
        MK: 'Macedonia',
        MG: 'Madagascar',
        MY: 'Malasia',
        MW: 'Malaui',
        MV: 'Maldivas',
        MT: 'Malta',
        ML: 'Malí',
        MA: 'Marruecos',
        MQ: 'Martinica',
        MU: 'Mauricio',
        MR: 'Mauritania',
        YT: 'Mayotte',
        FM: 'Micronesia',
        MD: 'Moldavia',
        MN: 'Mongolia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        MX: 'México',
        MC: 'Mónaco',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NI: 'Nicaragua',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolk',
        NO: 'Noruega',
        NC: 'Nueva Caledonia',
        NZ: 'Nueva Zelanda',
        NE: 'Níger',
        OM: 'Omán',
        PK: 'Pakistán',
        PW: 'Palaos',
        PS: 'Palestina',
        PA: 'Panamá',
        PG: 'Papúa Nueva Guinea',
        PY: 'Paraguay',
        NL: 'Países Bajos',
        PE: 'Perú',
        PF: 'Polinesia Francesa',
        PL: 'Polonia',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        GB: 'Reino Unido',
        CF: 'República Centroafricana',
        CZ: 'República Checa',
        CG: 'República del Congo',
        CD: 'República Democrática del Congo',
        DO: 'República Dominicana',
        EH: 'República Árabe Saharaui Democrática',
        RE: 'Reunión',
        RW: 'Ruanda',
        RO: 'Rumania',
        RU: 'Rusia',
        AS: 'Samoa Americana',
        WS: 'Samoa',
        BL: 'San Bartolomé',
        KN: 'San Cristóbal y Nieves',
        SM: 'San Marino',
        MF: 'San Martín',
        PM: 'San Pedro y Miquelón',
        VC: 'San Vicente y las Granadinas',
        SH: 'Santa Elena, Ascensión y Tristán de Acuña',
        LC: 'Santa Lucía',
        ST: 'Santo Tomé y Príncipe',
        SN: 'Senegal',
        RS: 'Serbia',
        SC: 'Seychelles',
        SL: 'Sierra Leona',
        SG: 'Singapur',
        SX: 'Sint Maarten',
        SY: 'Siria',
        SO: 'Somalia',
        LK: 'Sri Lanka',
        SZ: 'Suazilandia',
        ZA: 'Sudáfrica',
        SS: 'Sudán del Sur',
        SD: 'Sudán',
        SE: 'Suecia',
        CH: 'Suiza',
        SR: 'Surinam',
        SJ: 'Svalbard y Jan Mayen',
        TH: 'Tailandia',
        TW: 'Taiwán',
        TZ: 'Tanzania',
        TJ: 'Tayikistán',
        IO: 'Territorio Británico del Océano Índico',
        TF: 'Tierras Australes y Antárticas Francesas',
        TL: 'Timor Oriental',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad y Tobago',
        TM: 'Turkmenistán',
        TR: 'Turquía',
        TV: 'Tuvalu',
        TN: 'Túnez',
        UA: 'Ucrania',
        UG: 'Uganda',
        UY: 'Uruguay',
        UZ: 'Uzbekistán',
        VU: 'Vanuatu',
        VA: 'Vaticano, Ciudad del',
        VE: 'Venezuela',
        VN: 'Vietnam',
        WF: 'Wallis y Futuna',
        YE: 'Yemen',
        DJ: 'Yibuti',
        ZM: 'Zambia',
        ZW: 'Zimbabue',
    },
    en: {
        AF: 'Afghanistan',
        AX: 'Aland Islands',
        AL: 'Albania',
        DZ: 'Algeria',
        AS: 'American Samoa',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctica',
        AG: 'Antigua and Barbuda',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaijan',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BY: 'Belarus',
        BE: 'Belgium',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BQ: 'Boinaire, Saint Eustatius and Saba',
        BO: 'Bolivia',
        BA: 'Bosnia and Herzegovina',
        BW: 'Botswana',
        BV: 'Bouvet Island',
        BR: 'Brazil',
        IO: 'British Indian Ocean Territory',
        VG: 'British Virgin Islands',
        BN: 'Brunei Darussalam',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Cambodia',
        CM: 'Cameroon',
        CA: 'Canada',
        CV: 'Cape Verde',
        KY: 'Cayman Islands',
        CF: 'Central African Republic',
        TD: 'Chad',
        CL: 'Chile',
        CN: 'China',
        CX: 'Christmas Island',
        CC: 'Cocos (Keeling) Islands',
        CO: 'Colombia',
        KM: 'Comoros',
        CG: 'Congo (Brazzaville)',
        CD: 'Congo (Kinshasa)',
        CK: 'Cook Islands',
        CR: 'Costa Rica',
        HR: 'Croatia',
        CU: 'Cuba',
        CW: 'Curazao',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        CI: 'Côte d\'Ivoire',
        DK: 'Denmark',
        DJ: 'Djibouti',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        EC: 'Ecuador',
        EG: 'Egypt',
        SV: 'El Salvador',
        GQ: 'Equatorial Guinea',
        ER: 'Eritrea',
        EE: 'Estonia',
        ET: 'Ethiopia',
        FK: 'Falkland Islands (Malvinas)',
        FO: 'Faroe Islands',
        FJ: 'Fiji',
        FI: 'Finland',
        FR: 'France',
        GF: 'French Guiana',
        PF: 'French Polynesia',
        TF: 'French Southern Territories',
        GA: 'Gabon',
        GM: 'Gambia',
        GE: 'Georgia',
        DE: 'Germany',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Greece',
        GL: 'Greenland',
        GD: 'Grenada',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard and Mcdonald Islands',
        VA: 'Holy See (Vatican City State)',
        HN: 'Honduras',
        HK: 'Hong Kong, SAR China',
        HU: 'Hungary',
        IS: 'Iceland',
        IN: 'India',
        ID: 'Indonesia',
        IR: 'Iran, Islamic Republic of',
        IQ: 'Iraq',
        IE: 'Ireland',
        IM: 'Isle of Man',
        IL: 'Israel',
        IT: 'Italy',
        JM: 'Jamaica',
        JP: 'Japan',
        JE: 'Jersey',
        JO: 'Jordan',
        KZ: 'Kazakhstan',
        KE: 'Kenya',
        KI: 'Kiribati',
        KP: 'Korea (North)',
        KR: 'Korea (South)',
        XK: 'Kosovo',
        KW: 'Kuwait',
        KG: 'Kyrgyzstan',
        LA: 'Lao PDR',
        LV: 'Latvia',
        LB: 'Lebanon',
        LS: 'Lesotho',
        LR: 'Liberia',
        LY: 'Libya',
        LI: 'Liechtenstein',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        MO: 'Macao, SAR China',
        MK: 'Macedonia, Republic of',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malta',
        MH: 'Marshall Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Mexico',
        FM: 'Micronesia, Federated States of',
        MD: 'Moldova',
        MC: 'Monaco',
        MN: 'Mongolia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MA: 'Morocco',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        AN: 'Netherlands Antilles',
        NL: 'Netherlands',
        NC: 'New Caledonia',
        NZ: 'New Zealand',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolk Island',
        MP: 'Northern Mariana Islands',
        NO: 'Norway',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palau',
        PS: 'Palestinian Territory',
        PA: 'Panama',
        PG: 'Papua New Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippines',
        PN: 'Pitcairn',
        PL: 'Poland',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        QA: 'Qatar',
        RO: 'Romania',
        RU: 'Russian Federation',
        RW: 'Rwanda',
        RE: 'Réunion',
        SH: 'Saint Helena',
        KN: 'Saint Kitts and Nevis',
        LC: 'Saint Lucia',
        PM: 'Saint Pierre and Miquelon',
        VC: 'Saint Vincent and Grenadines',
        BL: 'Saint-Barthélemy',
        MF: 'Saint-Martin (French part)',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'Sao Tome and Principe',
        SA: 'Saudi Arabia',
        SN: 'Senegal',
        RS: 'Serbia',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapore',
        SX: 'Sint Maarten',
        SK: 'Slovakia',
        SI: 'Slovenia',
        SB: 'Solomon Islands',
        SO: 'Somalia',
        ZA: 'South Africa',
        GS: 'South Georgia and the South Sandwich Islands',
        SS: 'South Sudan',
        ES: 'Spain',
        LK: 'Sri Lanka',
        SD: 'Sudan',
        SR: 'Suriname',
        SJ: 'Svalbard and Jan Mayen Islands',
        SZ: 'Swaziland',
        SE: 'Sweden',
        CH: 'Switzerland',
        SY: 'Syrian Arab Republic (Syria)',
        TW: 'Taiwan, Republic of China',
        TJ: 'Tajikistan',
        TZ: 'Tanzania, United Republic of',
        TH: 'Thailand',
        TL: 'Timor-Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad and Tobago',
        TN: 'Tunisia',
        TR: 'Turkey',
        TM: 'Turkmenistan',
        TC: 'Turks and Caicos Islands',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        AE: 'United Arab Emirates',
        GB: 'United Kingdom',
        US: 'United States of America',
        UY: 'Uruguay',
        UM: 'US Minor Outlying Islands',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VE: 'Venezuela (Bolivarian Republic)',
        VN: 'Viet Nam',
        VI: 'Virgin Islands, US',
        WF: 'Wallis and Futuna Islands',
        EH: 'Western Sahara',
        YE: 'Yemen',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    de: {
        AF: 'Afghanistan',
        EG: 'Ägypten',
        AX: 'Aland-Inseln',
        AL: 'Albanien',
        DZ: 'Algerien',
        AS: 'Amerikanischen Samoa-Inseln',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarktis',
        AG: 'Antigua und Barbuda',
        GQ: 'Äquatorialguinea',
        SY: 'Arabische Republik Syrien (Syrien)',
        AR: 'Argentinien',
        AM: 'Armenien',
        AW: 'Aruba',
        AZ: 'Aserbaidschan',
        ET: 'Äthiopien',
        AU: 'Australien',
        BS: 'Bahamas',
        BH: 'Bahrein',
        BD: 'Bangladesch',
        BB: 'Barbados',
        BE: 'Belgien',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BQ: 'Boinaire, Sankt Eustatius und Saba',
        BO: 'Bolivien',
        BA: 'Bosnien und Herzegowina',
        BW: 'Botswana',
        BV: 'Bouvet-Insel',
        BR: 'Brasilien',
        VG: 'Britische Jungferninseln',
        IO: 'Britisches Territorium des Indischen Ozeans',
        BN: 'Brunei Darussalam',
        BG: 'Bulgarien',
        BF: 'Burkina Faso',
        MM: 'Burma',
        BI: 'Burundi',
        KY: 'Cayman Inseln',
        CL: 'Chile',
        CN: 'China',
        CK: 'Cookinseln',
        CR: 'Costa Rica',
        CW: 'Curazao',
        DK: 'Dänemark',
        DE: 'Deutschland',
        DM: 'Dominica',
        DO: 'Dominikanische Republik',
        DJ: 'Dschibuti',
        EC: 'Ecuador',
        SV: 'El Salvador',
        CI: 'Elfenbeinküste',
        ER: 'Eritrea',
        EE: 'Estland',
        FK: 'Falklandinseln (Malvinas)',
        FO: 'Färöer Inseln',
        FJ: 'Fidschi',
        FI: 'Finnland',
        FR: 'Frankreich',
        PF: 'Französisch Polynesien',
        GF: 'Französisch-Guayana',
        TF: 'Französische Süd- und Antarktisgebiete',
        GA: 'Gabun',
        GM: 'Gambia',
        TG: 'Gehen',
        GE: 'Georgia',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Grenada',
        GR: 'Griechenland',
        GL: 'Grönland',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GW: 'Guinea-Bissau',
        GN: 'Guinea',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard- und McDonald-Inseln',
        VA: 'Heiliger Stuhl (Vatikanstadt)',
        HN: 'Honduras',
        HK: 'Hongkong, Sonderverwaltungszone China',
        IN: 'Indien',
        ID: 'Indonesien',
        IQ: 'Irak',
        IR: 'Iran, Islamische Republik',
        IE: 'Irland',
        IS: 'Island',
        IM: 'Isle of Man',
        IL: 'Israel',
        IT: 'Italien',
        JM: 'Jamaika',
        JP: 'Japan',
        YE: 'Jemen',
        JE: 'Jersey',
        JO: 'Jordanien',
        VI: 'Jungferninseln, USA',
        KH: 'Kambodscha',
        CM: 'Kamerun',
        CA: 'Kanada',
        CV: 'Kap Verde',
        KZ: 'Kasachstan',
        QA: 'Katar',
        KE: 'Kenia',
        KG: 'Kirgistan',
        KI: 'Kiribati',
        CC: 'Kokosinseln (Keelinginseln).',
        CO: 'Kolumbien',
        KM: 'Komoren',
        CG: 'Kongo (Brazzaville)',
        CD: 'Kongo (Kinshasa)',
        XK: 'Kosovo',
        HR: 'Kroatien',
        CU: 'Kuba',
        KW: 'Kuwait',
        LA: 'Laos, Demokratische Volksrepublik',
        LS: 'Lesotho',
        LV: 'Lettland',
        LB: 'Libanon',
        LR: 'Liberia',
        LY: 'Libyen',
        LI: 'Liechtenstein',
        LT: 'Litauen',
        LU: 'Luxemburg',
        MO: 'Macao, Sonderverwaltungszone China',
        MG: 'Madagaskar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Malediven',
        ML: 'Mali',
        MT: 'Malta',
        MA: 'Marokko',
        MH: 'Marshallinseln',
        MQ: 'Martinique',
        MR: 'Mauretanien',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MK: 'Mazedonien, Republik',
        MX: 'Mexico',
        FM: 'Mikronesien, Föderierte Staaten von',
        MD: 'Moldawien',
        MC: 'Monaco',
        MN: 'Mongolei',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Mosambik',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NC: 'Neu-Kaledonien',
        NZ: 'Neuseeland',
        NI: 'Nicaragua',
        NL: 'Niederlande',
        AN: 'Niederländische Antillen',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        KP: 'Nordkorea',
        MP: 'Nördliche Marianneninseln',
        NF: 'Norfolkinsel',
        NO: 'Norwegen',
        OM: 'Oman',
        AT: 'Österreich',
        PK: 'Pakistan',
        PS: 'Palästinensisches Gebiet',
        PW: 'Palau',
        PA: 'Panama',
        PG: 'Papua Neu-Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippinen',
        PN: 'Pitcairn',
        PL: 'Polen',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        RE: 'Réunion',
        RW: 'Ruanda',
        RO: 'Rumänien',
        RU: 'Russische Föderation',
        BL: 'Saint-Barthélemy',
        MF: 'Saint-Martin (französischer Teil)',
        SB: 'Salomon-Inseln',
        ZM: 'Sambia',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'Sao Tome und Principe',
        SA: 'Saudi-Arabien',
        SE: 'Schweden',
        CH: 'Schweiz',
        SN: 'Senegal',
        RS: 'Serbien',
        SC: 'Seychellen',
        SL: 'Sierra Leone',
        SG: 'Singapur',
        SX: 'Sint Maarten',
        SK: 'Slowakei',
        SI: 'Slowenien',
        SO: 'Somalia',
        ES: 'Spanien',
        SJ: 'Spitzbergen und die Jan-Mayen-Inseln',
        LK: 'Sri Lanka',
        SH: 'St. Helena',
        KN: 'St. Kitts und Nevis',
        LC: 'St. Lucia',
        PM: 'St. Pierre und Miquelon',
        VC: 'St. Vincent und die Grenadinen',
        ZA: 'Südafrika',
        SD: 'Sudan',
        GS: 'Südgeorgien und die Südlichen Sandwichinseln',
        KR: 'Südkorea (Republik Korea)',
        SS: 'Südsudan',
        SR: 'Surinam',
        SZ: 'Swasiland',
        TJ: 'Tadschikistan',
        TW: 'Taiwan, Republik China',
        TZ: 'Tansania, Vereinigte Republik',
        TH: 'Thailand',
        TL: 'Timor-Leste',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad und Tobago',
        TR: 'Truthahn',
        TD: 'Tschad',
        CZ: 'Tschechien',
        TN: 'Tunesien',
        TM: 'Turkmenistan',
        TC: 'Turks- und Caicosinseln',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        HU: 'Ungarn',
        UY: 'Uruguay',
        UM: 'US Minor Outlying Islands',
        UZ: 'Usbekistan',
        VU: 'Vanuatu',
        VE: 'Venezuela (Bolivarische Republik)',
        AE: 'Vereinigte Arabische Emirate',
        US: 'Vereinigte Staaten von Amerika',
        GB: 'Vereinigtes Königreich',
        VN: 'Vietnam',
        WF: 'Wallis und Futuna-Inseln',
        CX: 'Weihnachtsinsel',
        BY: 'Weißrussland',
        EH: 'Westsahara',
        CF: 'Zentralafrikanische Republik',
        ZW: 'Zimbabwe',
        CY: 'Zypern',
    },
    pt: {
        AF: 'Afeganistão',
        ZA: 'África do Sul',
        AX: 'Åland',
        AL: 'Albânia',
        DE: 'Alemanha',
        AD: 'Andorra',
        AO: 'Angola',
        AQ: 'Antártica',
        AG: 'Antiga e barbuda',
        AN: 'Antilhas Holandesas',
        SA: 'Arábia Saudita',
        DZ: 'Argélia',
        AR: 'Argentina',
        AM: 'Armênia',
        AW: 'Aruba',
        AU: 'Austrália',
        AT: 'Áustria',
        AZ: 'Azerbaijão',
        BS: 'Bahamas',
        BH: 'Bahrein',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BE: 'Bélgica',
        BZ: 'Belize',
        BJ: 'Benim',
        BM: 'Bermudas',
        BY: 'Bielorrússia',
        BO: 'Bolívia',
        BQ: 'Bonaire, Santo Eustáquio e Saba',
        BA: 'Bósnia e Herzegovina',
        BW: 'Botsuana',
        BR: 'Brasil',
        BN: 'Brunei',
        BG: 'Bulgária',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        BT: 'Butão',
        CV: 'Cabo Verde',
        CM: 'Camarões',
        KH: 'Camboja',
        CA: 'Canadá',
        QA: 'Catar',
        KZ: 'Cazaquistão',
        TD: 'Chade',
        CL: 'Chile',
        CN: 'China',
        CY: 'Chipre',
        VA: 'Cidade do Vaticano',
        CO: 'Colômbia',
        KM: 'Comores',
        KP: 'Coréia do Norte',
        KR: 'Coreia do Sul',
        CI: 'Costa do Marfim',
        CR: 'Costa Rica',
        HR: 'Croácia',
        CU: 'Cuba',
        CW: 'Curaçao',
        DK: 'Dinamarca',
        DJ: 'Djibuti',
        DM: 'Dominica',
        EG: 'Egito',
        SV: 'El Salvador',
        AE: 'Emirados Árabes Unidos',
        AI: 'Enguia',
        EC: 'Equador',
        ER: 'Eritreia',
        SK: 'Eslováquia',
        SI: 'Eslovênia',
        ES: 'Espanha',
        US: 'Estados Unidos',
        EE: 'Estônia',
        ET: 'Etiópia',
        FJ: 'Fiji',
        PH: 'Filipinas',
        FI: 'Finlândia',
        FR: 'França',
        GA: 'Gabão',
        GM: 'Gâmbia',
        GH: 'Gana',
        GE: 'Geórgia',
        GI: 'Gibraltar',
        GD: 'Granada',
        GR: 'Grécia',
        GL: 'Gronelândia',
        GP: 'Guadalupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GY: 'Guiana',
        GF: 'Guiana Francesa',
        GN: 'Guiné',
        GQ: 'Guiné Equatorial',
        GW: 'Guiné-Bissau',
        HT: 'Haiti',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungria',
        YE: 'Iémen',
        BV: 'Ilha Bouvet',
        IM: 'Ilha do Man',
        CX: 'Ilha do Natal',
        KY: 'Ilhas Cayman',
        CC: 'Ilhas Cocos',
        CK: 'Ilhas Cook',
        UM: 'Ilhas Distantes dos Estados Unidos',
        FO: 'Ilhas Faroe',
        GS: 'Ilhas Geórgia do Sul e Sandwich do Sul',
        HM: 'Ilhas Heard e McDonald',
        FK: 'Ilhas Malvinas',
        MP: 'Ilhas Marianas do Norte',
        MH: 'Ilhas Marshall',
        PN: 'Ilhas Pitcairn',
        SB: 'Ilhas Salomão',
        TC: 'Ilhas Turcas e Caicos',
        VI: 'Ilhas Virgens Americanas',
        VG: 'Ilhas Virgens Britânicas',
        IN: 'Índia',
        ID: 'Indonésia',
        IR: 'Irã',
        IQ: 'Iraque',
        IE: 'Irlanda',
        IS: 'Islândia',
        IL: 'Israel',
        IT: 'Itália',
        JM: 'Jamaica',
        JP: 'Japão',
        JE: 'Jersey',
        JO: 'Jordânia',
        KI: 'Kiribati',
        XK: 'Kosovo',
        KW: 'Kuwait',
        LA: 'Laos',
        LS: 'Lesoto',
        LV: 'Letônia',
        LB: 'Líbano',
        LR: 'Libéria',
        LY: 'Líbia',
        LI: 'Liechtenstein',
        LT: 'Lituânia',
        LU: 'Luxemburgo',
        MO: 'Macau',
        MK: 'Macedônia',
        MG: 'Madagáscar',
        YT: 'Maiote',
        MY: 'Malásia',
        MW: 'Malauí',
        MV: 'Maldivas',
        ML: 'Mali',
        MT: 'Malta',
        MA: 'Marrocos',
        MQ: 'Martinica',
        MU: 'Maurício',
        MR: 'Mauritânia',
        MX: 'México',
        MM: 'Mianmar',
        FM: 'Micronésia',
        MZ: 'Moçambique',
        MD: 'Moldávia',
        MC: 'Mônaco',
        MN: 'Mongólia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        NA: 'Namíbia',
        NR: 'Nauru',
        NP: 'Nepal',
        NI: 'Nicarágua',
        NE: 'Níger',
        NG: 'Nigéria',
        NU: 'Niue',
        NF: 'Norfolk',
        NO: 'Noruega',
        NC: 'Nova Caledônia',
        NZ: 'Nova Zelândia',
        OM: 'Omã',
        NL: 'Países Baixos',
        PW: 'Palau',
        PS: 'Palestina',
        PA: 'Panamá',
        PG: 'Papua Nova Guiné',
        PK: 'Paquistão',
        PY: 'Paraguai',
        PE: 'Peru',
        PF: 'Polinésia Francesa',
        PL: 'Polônia',
        PR: 'Porto Rico',
        PT: 'Portugal',
        KE: 'Quênia',
        KG: 'Quirguistão',
        GB: 'Reino Unido',
        EH: 'República Árabe Saarauí Democrática',
        CF: 'República Centro-Africano',
        CZ: 'Republica Checa',
        CD: 'República Democrática do Congo',
        CG: 'República do Congo',
        DO: 'República Dominicana',
        RE: 'Reunião',
        RO: 'Romênia',
        RW: 'Ruanda',
        RU: 'Rússia',
        SX: 'Saint Maarten',
        WS: 'Samoa',
        AS: 'Samoa Americana',
        SM: 'San Marino',
        SH: 'Santa Helena, Ascensão e Tristão de Acuña',
        LC: 'Santa Lúcia',
        BL: 'São Bartolomeu',
        KN: 'São Cristóvão e Nevis',
        MF: 'São Martim',
        PM: 'São Pedro e Miquelon',
        ST: 'São Tomé e Príncipe',
        VC: 'São Vicente e Granadinas',
        SN: 'Senegal',
        SL: 'Serra Leoa',
        RS: 'Sérvia',
        SC: 'Seychelles',
        SG: 'Singapura',
        SY: 'Síria',
        SO: 'Somália',
        LK: 'Sri Lanka',
        SZ: 'Suazilândia',
        SD: 'Sudão',
        SS: 'Sudão do Sul',
        SE: 'Suécia',
        CH: 'Suíça',
        SR: 'Suriname',
        SJ: 'Svalbard e Jan Mayen',
        TJ: 'Tadjiquistão',
        TH: 'Tailândia',
        TW: 'Taiwan',
        TZ: 'Tanzânia',
        TF: 'Terras Austrais e Antárticas Francesas',
        IO: 'Território Britânico do Oceano Índico',
        TL: 'Timor Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trindade e Tobago',
        TN: 'Tunísia',
        TR: 'Türkiye',
        TM: 'Turquemenistão',
        TV: 'Tuvalu',
        UA: 'Ucrânia',
        UG: 'Uganda',
        UY: 'Uruguai',
        UZ: 'Uzbequistão',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Vietname',
        WF: 'Wallis e Futuna',
        ZM: 'Zâmbia',
        ZW: 'Zimbábue',
    },
});
